import { useMutation } from '@maui/react-query'
import { useTpNotificationsApiClient } from './client'
import { useQuery } from '../../utils/helpers'

const normalizeTpNotifications = (data) => (
  data?.notification_jobs?.map((tp) => {
    return {
      ...tp,
      displayName: tp.display_name,
      reportType: 'Threat Profile Digest'
    }
  })
    .sort((a, b) => a.name.localeCompare(b.name))
)

const adapters = {
  default: normalizeTpNotifications,
  raw: (data) => data,
}

export const useFetchAllThreatProfileNotificationJobs = (options = {}) => {
  const api = useTpNotificationsApiClient('notifications')
  return useQuery({
    queryFn: () => api.fetchAll(),
    queryKey: ['allNotificationJobs'],
    adapters,
    ...options
  })
}

export const useCreateThreatProfileNotification = (options = {}) => {
  const api = useTpNotificationsApiClient('notifications')
  return useMutation({
    mutationFn: (profile) => api.createNotificationJob(profile),
    invalidateKeys: ['allNotificationJobs'],
    ...options
  })
}

export const useRemoveTpNotificationJob = (options = {}) => {
  const api = useTpNotificationsApiClient('notifications')
  return useMutation({
    mutationFn: ({ id }) => api.remove({ id }),
    invalidateKeys: ['allNotificationJobs'],
    ...options
  })
}

export const useUpdateThreatProfileNotification = (options = {}) => {
  const api = useTpNotificationsApiClient('notifications')
  return useMutation({
    mutationFn: ({ id, payload }) => api.update({ id, payload }),
    invalidateKeys: ['allNotificationJobs'],
    ...options
  })
}
